import * as React from 'react';
import { useSelector } from 'react-redux';

import { Page } from '../../components/Page';
import { Filters } from '../../components/Filters';
import { Summary } from '../../components/Summary';
import { ContentSection } from '../../components/ContentSection';

import { ListingContainer } from '../ListingContainer';
import { PaginationContainer } from '../PaginationContainer';
import { DealTypeContainer, OfferTypeContainer, SearchTextLayout, SortFilterContainer } from '../Filters';
import { TabsContainer } from '../TabsContainer';
import { PageMetaContainer } from '../PageMetaContainer';
import { TotalCountTextContainer } from '../TotalCountTextContainer';
import { GeoLocationContainer } from '../Filters/GeoLocationContainer';
import { getIsLoading } from '../../selectors/listing';
import { ListingPreloader } from '../../components/ListingPreloader';
import { TitleContainer } from '../TitleContainer';
import { RatingBannerContainer } from '../RatingBannerContainer';
import { CallUsBanner } from '../CallUsBanner';
import { AdvertisingLabelingContainer } from '../AdvertisingLabelingContainer';
import { NoSsr } from '@cian/react-utils';

export function PageContainer() {
  const isLoadListing = useSelector(getIsLoading);

  return (
    <Page>
      <PageMetaContainer />
      <TitleContainer />
      <TabsContainer />
      <Filters
        regionFilter={<GeoLocationContainer />}
        dealTypeFilter={<DealTypeContainer />}
        offerTypeFilter={<OfferTypeContainer />}
        searchTextFilter={<SearchTextLayout />}
      />
      <ContentSection>
        {isLoadListing && <ListingPreloader />}
        <Summary total={<TotalCountTextContainer />} sortFilter={<SortFilterContainer />} />
        <NoSsr>
          <CallUsBanner />
        </NoSsr>
        <ListingContainer />
        <PaginationContainer />
        <RatingBannerContainer />
        <AdvertisingLabelingContainer />
      </ContentSection>
    </Page>
  );
}
